<div class="new_chat_wrapper"
  [ngClass]="{'new_chat_wrapper-w-full' : isFullWidth ||  draggingWidth , 'new_chat_wrapper' : !isFullWidth && !draggingWidth}">
  <div class="new_chat_header">
    <img src="assets/images/robot-avatar.png" alt="logo">
  </div>
  <div class=""
    [ngClass]="{'new_chat_content_wrapper-w-full' : isFullWidth ||  draggingWidth , 'new_chat_content_wrapper' : !isFullWidth && !draggingWidth}">
    <div class="new_chat_content">
      <div class="content_header">
        <mat-icon>light_mode</mat-icon>
        <p>Examples</p>
      </div>
      <div class="content_card">
        <p>What is Capacity Utilization of Plant {{plantName}}?</p>
      </div>
      <div class="content_card">
        <p>What is the OEE of DieMaking between Feb 27, 2022 and Feb 28, 2022?</p>
      </div>
      <div class="content_card">
        <p>What is Quality of Line Roto?</p>
      </div>
    </div>
    <div class="new_chat_content">
      <div class="content_header">
        <mat-icon>bolt</mat-icon>
        <p>Capabilities</p>
      </div>
      <div class="content_card">
        <p>Able to provide accurate results with in atleast 12 sec</p>
      </div>
      <div class="content_card">
        <p>Allows user to ask anything about productivity of {{plantName}} with respect to plant, line and machine</p>
      </div>
      <div class="content_card">
        <p>Trained to decline inappropriate requests</p>
      </div>
    </div>
    <div class="new_chat_content">
      <div class="content_header">
        <mat-icon>report_problem</mat-icon>
        <p>Limitations</p>
      </div>
      <div class="content_card">
        <p>May occasionally generate incorrect information</p>
      </div>
      <div class="content_card">
        <p>Some queries like calculation of best or worst productivity metric among all plants or lines or units will
          take at max 4 minutes</p>
      </div>
      <div class="content_card">
        <p>Have limited knowledge of O3 Enterprise Database only about {{plantName}} Plant</p>
      </div>
    </div>
  </div>
</div>